export const OPENINGS = [
    {
        title: '🖥️ Full-stack Software Engineer',
        description: "We're seeking passionate and driven Full-stack Software Engineers to join our growing collective. This is a unique opportunity to shape the future of our product offerings and directly contribute to impactful social good initiatives. You'll thrive in an environment that values autonomy, collaboration, and a shared commitment to making a difference. As an early member of our team, you'll have significant influence and the potential to grow into a Director of Engineering role.",
        cta: {
            label: 'Apply',
            url: '/careers/full-stack-engineer',
        }
    },
]